export const CHANNEL_TALK_URL = 'https://bznavcare1.channel.io';
